import { useQuery } from "@tanstack/react-query";
import { ApiGetCexAutoTradeUserSetting } from "@/api";
import type {
  GetCexAutoTradeUserSettingRequest,
  GetCexAutoTradeUserSettingResponse,
} from "@/api/types";
import { getToken } from "@/lib/auth";
import { useUserStore } from "@/store/useUserStore";

export function useGetCexAutoTradeUserSetting() {
  const { userInfo } = useUserStore();
  return useQuery({
    queryKey: ["cexAutoTradeUserSetting"],
    queryFn: async (): Promise<GetCexAutoTradeUserSettingResponse> => {
      const res = await ApiGetCexAutoTradeUserSetting({});
      console.log("ApiGetCexAutoTradeUserSetting", res);
      return res.data;
    },
    enabled: !!userInfo?.address,
    refetchInterval: 15000,
  });
}
